'use client';

/**
 * ./src/modules/product/pages/GetInspiredPageTemplate.tsx
 *
 * SamplesList component to display a list of collections
 *
 * @copyright DesignShop, 2024
 * @since 10/29/2024
 */
import { useRef } from 'react';
import { Configure, InstantSearch } from 'react-instantsearch';

import useIsMobile from '@/modules/common/hooks/useIsMobile';
import { ALGOLIA_COLLECTION_PUBLISHED_FILTER } from '@/modules/common/services/algoliaConstants';
import { ALGOLIA_COLLECTION_INDEX } from '@/modules/common/services/constants';
import { useFinder } from '@/modules/cora/context/FinderProvider';
import { searchClient } from '@/modules/product/components/AlgoliaSearch/AlgoliaProvider';
import CollectionGrid from '@/modules/product/components/collections/CollectionGrid';
import GetInspiredFilters from '@/modules/product/components/collections/GetInspired/GetInspiredFilters';

import { useSeoFriendlyRouter } from '../hooks/useSeoFriendlyRouter';

export const GetInspiredPageTemplate = () => {
  const isMobile = useIsMobile();
  const loadMoreRef = useRef<HTMLDivElement>(null);

  const { filtersDefinition } = useFinder();

  const customRouting = useSeoFriendlyRouter({
    algoliaIndex: ALGOLIA_COLLECTION_INDEX,
    filters: filtersDefinition,
  });

  return (
    <>
      <div className="bg-white lg:px-0">
        <div className="mb-8">
          <h1 className="pb-2 pt-9 text-center text-2xl font-bold leading-8 lg:pb-4 lg:pt-10 lg:text-5xl lg:leading-[48px]">
            Shop Inspiration
          </h1>
          <InstantSearch
            searchClient={searchClient}
            indexName={ALGOLIA_COLLECTION_INDEX}
            routing={customRouting}
          >
            <Configure
              filters={ALGOLIA_COLLECTION_PUBLISHED_FILTER}
              hitsPerPage={isMobile ? 6 : 15}
            />
            <GetInspiredFilters />
            <CollectionGrid loadMoreRef={loadMoreRef} />
          </InstantSearch>
        </div>
      </div>
      <div
        ref={loadMoreRef}
        className="mt-8 flex h-10 items-center justify-center"
        data-testid="load-more-ref"
      />
    </>
  );
};
